export enum TemplateChannel {
  EDIT = 'template::patch',
  CREATE = 'template::create',
  DELETE = 'template::delete',
}
